<form [formGroup]="recurringDepositProductSettingsForm">
  <div class="layout-row-wrap gap-2px responsive-column">
    <mat-checkbox labelPosition="before" formControlName="isMandatoryDeposit" class="margin-v flex-48">
      {{ 'labels.inputs.Is Mandatory Deposit' | translate }}
    </mat-checkbox>

    <mat-checkbox class="flex-48 margin-v" labelPosition="before" formControlName="adjustAdvanceTowardsFuturePayments">
      {{ 'labels.inputs.Adjust advance payments toward future installments' | translate }}
    </mat-checkbox>

    <mat-checkbox labelPosition="before" formControlName="allowWithdrawal" class="margin-v flex-48">
      {{ 'labels.inputs.Allow Withdrawals' | translate }}
    </mat-checkbox>

    <h4 class="mat-h4 flex-98">{{ 'labels.inputs.Lock-in Period' | translate }}</h4>

    <mat-form-field class="flex-48">
      <mat-label>{{ 'labels.inputs.Frequency' | translate }}</mat-label>
      <input
        type="number"
        matInput
        formControlName="lockinPeriodFrequency"
        matTooltip="{{ 'tooltips.The number at which lock in period occurs' | translate }}"
      />
    </mat-form-field>

    <mat-form-field class="flex-48">
      <mat-label>{{ 'labels.inputs.Type' | translate }}</mat-label>
      <mat-select formControlName="lockinPeriodFrequencyType">
        @for (lockinPeriodFrequencyType of lockinPeriodFrequencyTypeData; track lockinPeriodFrequencyType) {
          <mat-option [value]="lockinPeriodFrequencyType.id">
            {{ lockinPeriodFrequencyType.value }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <h4 class="mat-h4 flex-98">{{ 'labels.inputs.Minimum Deposit Term' | translate }}</h4>

    <mat-form-field class="flex-48">
      <mat-label>{{ 'labels.inputs.Frequency' | translate }}</mat-label>
      <input
        type="number"
        matInput
        formControlName="minDepositTerm"
        matTooltip="{{ 'tooltips.The number at which minimum deposit occurs' | translate }}"
        required
      />
      <mat-error>
        {{ 'labels.inputs.Minimum Deposit Term Frequency' | translate }} {{ 'labels.commons.is' | translate }}
        <strong>{{ 'labels.commons.required' | translate }}</strong>
      </mat-error>
    </mat-form-field>

    <mat-form-field class="flex-48">
      <mat-label>{{ 'labels.inputs.Frequency Type' | translate }}</mat-label>
      <mat-select formControlName="minDepositTermTypeId" required>
        @for (periodFrequencyType of periodFrequencyTypeData; track periodFrequencyType) {
          <mat-option [value]="periodFrequencyType.id">
            {{ periodFrequencyType.value }}
          </mat-option>
        }
      </mat-select>
      <mat-error>
        {{ 'labels.inputs.Minimum Deposit Term Frequency Type' | translate }} {{ 'labels.commons.is' | translate }}
        <strong>{{ 'labels.commons.required' | translate }}</strong>
      </mat-error>
    </mat-form-field>

    <h4 class="mat-h4 flex-98">{{ 'labels.heading.And thereafter, in Multiples of' | translate }}</h4>

    <mat-form-field class="flex-48">
      <mat-label>{{ 'labels.inputs.Frequency' | translate }}</mat-label>
      <input
        type="number"
        matInput
        formControlName="inMultiplesOfDepositTerm"
        matTooltip="{{ 'tooltips.The number at which multiple deposits occurs' | translate }}"
      />
    </mat-form-field>

    <mat-form-field class="flex-48">
      <mat-label>{{ 'labels.inputs.Type' | translate }}</mat-label>
      <mat-select formControlName="inMultiplesOfDepositTermTypeId">
        @for (periodFrequencyType of periodFrequencyTypeData; track periodFrequencyType) {
          <mat-option [value]="periodFrequencyType.id">
            {{ periodFrequencyType.value }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <h4 class="mat-h4 flex-98">{{ 'labels.inputs.Maximum Deposit Term' | translate }}</h4>

    <mat-form-field class="flex-48">
      <mat-label>{{ 'labels.inputs.Frequency' | translate }}</mat-label>
      <input
        type="number"
        matInput
        formControlName="maxDepositTerm"
        matTooltip="{{ 'tooltips.The number at which minimum deposit occurs' | translate }}"
      />
    </mat-form-field>

    <mat-form-field class="flex-48">
      <mat-label>{{ 'labels.inputs.Type' | translate }}</mat-label>
      <mat-select formControlName="maxDepositTermTypeId">
        @for (periodFrequencyType of periodFrequencyTypeData; track periodFrequencyType) {
          <mat-option [value]="periodFrequencyType.id">
            {{ periodFrequencyType.value }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-divider class="flex-98"></mat-divider>

    <h4 class="mat-h4 flex-23">{{ 'labels.heading.For Pre-mature closure' | translate }}</h4>

    <mat-checkbox class="flex-73 margin-v" labelPosition="before" formControlName="preClosurePenalApplicable">
      {{ 'labels.inputs.Apply Penal Interest (less)' | translate }}
    </mat-checkbox>

    <mat-form-field class="flex-48">
      <mat-label>{{ 'labels.inputs.Penal Interest' | translate }} (%)</mat-label>
      <input type="number" matInput formControlName="preClosurePenalInterest" />
    </mat-form-field>

    <mat-form-field class="flex-48">
      <mat-label>{{ 'labels.inputs.Period' | translate }}</mat-label>
      <mat-select formControlName="preClosurePenalInterestOnTypeId">
        @for (preClosurePenalInterestOnType of preClosurePenalInterestOnTypeData; track preClosurePenalInterestOnType) {
          <mat-option [value]="preClosurePenalInterestOnType.id">
            {{ preClosurePenalInterestOnType.value }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-divider class="flex-98"></mat-divider>

    <mat-checkbox labelPosition="before" formControlName="withHoldTax" class="margin-v flex-48">
      {{ 'labels.inputs.Is Withhold Tax Applicable' | translate }}
    </mat-checkbox>

    @if (recurringDepositProductSettingsForm.value.withHoldTax) {
      <mat-form-field class="flex-48">
        <mat-label>{{ 'labels.inputs.Tax Group' | translate }}</mat-label>
        <mat-select formControlName="taxGroupId" required>
          @for (taxGroup of taxGroupData; track taxGroup) {
            <mat-option [value]="taxGroup.id">
              {{ taxGroup.name }}
            </mat-option>
          }
        </mat-select>
        <mat-error>
          {{ 'labels.inputs.Tax Group' | translate }} {{ 'labels.commons.is' | translate }}
          <strong>{{ 'labels.commons.required' | translate }}</strong>
        </mat-error>
      </mat-form-field>
    }
  </div>

  <div class="layout-row align-center gap-2percent margin-t responsive-column">
    <button mat-raised-button matStepperPrevious>
      <fa-icon icon="arrow-left" class="m-r-10"></fa-icon>
      {{ 'labels.buttons.Previous' | translate }}
    </button>
    <button mat-raised-button matStepperNext>
      {{ 'labels.buttons.Next' | translate }}
      <fa-icon icon="arrow-right" class="m-l-10"></fa-icon>
    </button>
  </div>
</form>
